/*
 * Created by: cparaschiv
 * Date: 24.01.2013, 13:01
 */

/** @module TS.Util */
TS.Util = TS.Util || {};

(function(){
    'use strict';

    /** exports */
    $.extend(TS.Util, {

        setAspArgs: function(opts, target, argument) {
            var c = TS.Constants;
            opts[c.EventTarget] = target;
            opts[c.EventArgument] = argument;
            return opts;
        },

        /**
         * Returns the value of an object property, given a dot-delimited path.
         * @param obj {Object} The source object
         * @param path {String} A dot-delimited path
         * @param [skipUnwrap=false] {Boolean} When set to true it returns observable objects instead of their values
         * @returns {*}
         * @static
         * @example
         * var person = {
         *    leftHand: {
         *      thumb: 'pinky'
         *    }
         * };
         * var thumbName = TS.Util.getProperty(person, 'leftHand.thumb'); //'pinky'
         */
        getProperty: function(obj, path, skipUnwrap) {
            var parts = (path || '').split('.'),
                i = 0, part, ret = null,
                unwrap = !skipUnwrap,
                forceUnwrap = false;

            if (!obj)
                return null;

            for(i = 0; i<parts.length; i++) {
                part = parts[i];

                forceUnwrap = false;
                if (part.indexOf('()') == part.length - 2) {
                    part = part.substr(0, part.length - 2);
                    forceUnwrap = true;
                }

                if(unwrap || forceUnwrap) {
                    obj = TS.unwrap(obj[part]);
                } else {
                    obj = obj[part];
                }

                ret = obj;

                //this part does not exist, no need to continue
                if (typeof obj === 'undefined' || obj === null){
                    break;
                }
            }

            return ret;
        },

        getParentPropertyValue: function(obj, path) {
            var parts = (path || '').split('.'),
                i = 0, part, ret = null;

            if (!obj)
                return null;

            if (parts.length == 1)
                return obj;

            for(i = 0; i<parts.length - 1; i++) {
                part = parts[i];
                if (typeof obj[part] == "object"){
                    obj = obj[part];
                    ret = obj;
                } else if (typeof obj[part] == "function"){
                    obj = obj[part]();
                    ret = obj;
                }
            }

            return ret;
        },

        getLastPropertyName: function(path) {
            var parts = (path || '').split('.');
            return parts[parts.length - 1];
        },
        /**
         * Returns a [GUID]{@link http://en.wikipedia.org/wiki/Globally_unique_identifier}
         * @returns {String}
         * @static
         * @example
         * console.log(TS.Util.createGuid()); //"3412e366-822a-3751-90fc-e2e87a54e518"
         */
        createGuid: function(){
            var s4 = function() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            };

            return  s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                    s4() + '-' + s4() + s4() + s4();
        },

        findIndex: function(array, value, propName){
            var idx = -1;

            if (!array)
                return idx;

            $.each(array, function(i, item){
                if (item[propName] === value){
                    idx = i;
                    return false;
                }
            });

            return idx;
        },

        find: function(array, propName, value){
            var ret = null;

            if (!array)
                return ret;

            $.each(TS.unwrap(array), function(i, item){
                if (TS.unwrap(item[propName]) === value){
                    ret = item;
                    return false;
                }
            });

            return ret;
        },

        /**
         * Returns a human-readable representation of a byte size.
         * @param bytes A number.
         * @returns {String}
         * @static
         * @example
         * var kilo = 1024,
         *     size1 = 3*kilo + 513,
         *     size2 = 5*kilo*kilo + 20*kilo;
         *
         * console.log(TS.Util.formatBytes(size1)); //'4 KB'
         * console.log(TS.Util.formatBytes(size2)); //'5.02 MB'
         */
        formatBytes: function (bytes) {
            if (typeof bytes !== 'number') {
                return '';
            }

            var size = bytes,
                suffixes = ['KB', 'MB', 'GB', 'TB'],
                precisions = [0, 2, 2, 2],
                i = 0,
                suffix,
                ret = size + ' B';

            while (size >= 1024) {
                size = size / 1024;
                suffix = suffixes[i];
                ret = size.toFixed(precisions[i]) + ' ' + suffix;
                i++;
            }

            return ret;
        },

        getNotifications: function(resp){
            var ret = {
                validationerrors: '',
                errors: '',
                warnings: '',
                informations: ''
            };

            if (resp.messages) {
                if (TS.isArray(resp.messages)){
                    $.each(resp.messages, function (idx, msg) {
                        // ignore confirmation messages (messages with buttons YesNoCancel).  See TS.App.Web.WebApi.MessageBoxButtons enum.
                        if(msg.buttons !== 3)
                            ret[msg.type + 's'] += msg.text + "<br />";
                    });
                }
            }

            return ret;
        },

        getRequestVerificationToken: function () {
            var ret = $('[name=__RequestVerificationToken]').first().val();

            if (ret === undefined) {
                return '';
            }

            return ret;
        },

        /**
         * Verifies that two object are similar by ignoring differences between <code>null</code> and <code>undefined</code>.
         * The two objects must have similar properties. If one of the objects has additional properties that
         * the other one doesn't, it returns false.
         * <p><span class="label label-important">Important</span>
         * This function does not perform deep comparison.
         * </p>
         * @param obj1 {Object} First object
         * @param obj2 {Object} Second object
         * @returns {Boolean}
         * @static
         *
         * @example
         *
         * var obj1 = {
         *   prop1: 'a',
         *   prop2: null,
         *   prop3: 'b'
         * };
         * var obj2 = {
         *   prop1: 'a',
         *   prop2: undefined,
         *   prop3: 'b'
         * };
         *
         * TS.log(TS.Util.areSimilar(obj1, obj2));
         * // Output: true
         */
        areSimilar: function(obj1, obj2){
            var key;

            if ( (obj1 === null && obj2 === null)
                || (obj1 === undefined && obj2 === undefined) )
                return true;

            for(key in obj1){
                if (!obj2.hasOwnProperty(key))
                    return false;

                if (obj1[key] != obj2[key]){
                    return false;
                }
            }

            for(key in obj2){
                if (!obj1.hasOwnProperty(key))
                    return false;

                if (obj2[key] != obj1[key]){
                    return false;
                }
            }

            return true;
        },

        kendoNumericFormat: function(decimals, useThousandSeparator){
            var fmt = '#';
            decimals = decimals || 0;

            if (useThousandSeparator === false) {
                fmt = '#.' + (new Array(decimals + 1)).join("#");
            } else {
                fmt = 'n' + decimals.toString();
            }

            return fmt;
        },

        capitalize: function(str) {
            if (!str) {
                return str;
            }
            return str.charAt(0).toUpperCase() + str.slice(1);
        },

        removeTrailingSlash: function(url) {
            var ret = url;
             // remove trailing slash
            if (ret && (typeof ret === 'string')) {
            	if (ret.charAt(ret.length - 1) == '/') {
            		ret = ret.substring(0, ret.length - 1);
                }
            }
            return ret;
        },

        setObservableWithoutRaisingSubscriptions: function (observable, value) {
            var subscriptions;
            if (!$.isFunction(observable))
                return;
            if (observable._subscriptions) {
                subscriptions = observable._subscriptions;
                observable._subscriptions = {};
            }
            observable(value);
            if (subscriptions)
                observable._subscriptions = subscriptions;
        }
    });

    Date.prototype.toJSON = function (key) {

        return isFinite(this.valueOf())
            ? moment(this).format("YYYY-MM-DD[T]HH:mm:ss.SSSZZ") //this.format("yyyy-mm-dd'T'HH:MM:sso")
            : null;
    };

})();